import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import EventTracker from "../utils/EventTracker";
import "./Topbar.css";

export default function Topbar(props) {
  const navigate = useNavigate();
  const { isHideBackHeader, headerTitleText } = useSelector(
    (state) => state.commonState
  );

  const currentPath = window.location.pathname.split("/");

  const handleHomeIconClick = () => {
    const properties = {
      Type: "Small Insights Home Icon ",
    };
    EventTracker.instance.trackEvent("Small Insights Home Icon ", properties);

    navigate("/zone");
  };

  const handleClose = () => {
    window.flutter_inappwebview.callHandler("gameCloseEvent_closeGame", "*");
  };

  return (
    <>
      {!isHideBackHeader && (
        <div
          className={`container-menu mobile-back-btn-header container custom-position${
            props.styleClass ? props.styleClass : ""
          }`}
        >
          <div className="back-btn-icon-container ">
            {currentPath[currentPath.length - 1] === "mci" ? (
              <img
                className="home-page-img"
                onClick={handleHomeIconClick}
                src="https://cdn.mindpeers.co/dark-mode/user-insights/home-page-icon.svg"
                alt="home page icon"
              />
            ) : (
              <img
                onClick={
                  props.afterClick ? props.afterClick : () => handleClose()
                }
                src="https://cdn.mindpeers.co/dark-mode/site-icons/common/back.svg"
                alt="Back"
              />
            )}
          </div>

          <div className="back-btn-header-title-text">{headerTitleText}</div>
        </div>
      )}
    </>
  );
}
